module.exports = __webpack_public_path__ + "images/pattern.svg";


//////////////////
// WEBPACK FOOTER
// ./images/pattern.svg
// module id = 13
// module chunks = 1